import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';
import { useAuthContext } from '../context';

export const useVerifyEmail = () => {
  const {
    methods: { setUser },
  } = useAuthContext();

  return useMutation({
    mutationFn: async (values: { code: string }) => {
      const { data } = await Api.VerifyEmail(values);
      return data;
    },
    onSuccess: (data) => {
      // Lift the email-verification gate by refreshing user state.
      setUser(data.user);
    },
  });
};
